import i18n from 'modules/core/lib/i18n'

import {
  InsightTableGroupBy,
  InsightTableType,
} from 'modules/finance/components/FinancialWorkspace/types/table'

import { useOnExport } from '../../exports/useExport'
import { useEmployeeCostData } from '../../hooks/useEmployeeCostData'
import { GroupBySelector } from './components/GroupBy'
import { resolveTitle } from './const'

export const useTableProps = () => {
  return {
    useOnExport,
    titleResolver: resolveTitle,
    groupByComponent: GroupBySelector,
    useDataFetch: useEmployeeCostData,
    hideSearch: (group?: InsightTableGroupBy) => {
      return group === InsightTableGroupBy.Total || group === undefined
    },
    emptyStateProps: {
      title: i18n.t('finance.financial_workspace.breakdown_table.empty_state.payroll.title'),
      description: i18n.t(
        'finance.financial_workspace.breakdown_table.empty_state.payroll.description'
      ),
    },
    type: InsightTableType.EmployeeCosts,
  }
}
